module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_pc_nicole-889ea36548b49b068068bf6e51e22ff3.png";